export * from './SelectedMaterialsListItemLightboxTitle.types';
export { default as SelectedMaterialsListItemLightboxTitle } from './SelectedMaterialsListItemLightboxTitle';
